import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './UpgradeSuccess.css';

const UpgradeSuccess = () => {
  const { user } = useAuth();

  return (
    <div className="upgrade-success-container">
      <div className="upgrade-success-card">
        <div className="success-icon">✅</div>
        <h1>Subscription Successful!</h1>
        <p className="success-message">
          Your account has been successfully upgraded to Premium.
        </p>
        {user?.is_premium && (
          <div className="premium-badge">
            <span>⭐ Premium Member</span>
          </div>
        )}
        <div className="success-benefits">
          <h2>You now have access to:</h2>
          <ul>
            <li>✨ Unlimited AI-powered book summaries</li>
            <li>📚 Generate summaries for any book</li>
            <li>💾 Save unlimited books to your collection</li>
            <li>⭐ Rate summaries and ask questions</li>
            <li>📖 Generate study guides and discussion outlines</li>
            <li>🚀 Priority support</li>
          </ul>
        </div>
        <div className="success-actions">
          <Link to="/search" className="btn btn-primary">
            Search Books
          </Link>
          <Link to="/" className="btn btn-secondary">
            Go to Dashboard
          </Link>
        </div>
      </div>
    </div>
  );
};

export default UpgradeSuccess;
